import React from "react";
import { WarningCircle, Plus } from "@phosphor-icons/react";

// Media buyer links used on pages they weren't given: leads came in but earned them no credit.
export function MissedCreditCard({ missed, onGive, busyKey }) {
  if (!missed.length) return null;
  return (
    <section className="border-2 border-amber-700 bg-amber-50 p-4 mb-6" data-testid="traffic-missed-card">
      <div className="flex items-center gap-2 mb-1">
        <WarningCircle size={18} weight="bold" className="text-amber-800" />
        <div className="font-chivo font-black uppercase tracking-tighter">Missed media buyer credit</div>
        <span className="label-mono">last 30 days</span>
      </div>
      <p className="text-[11px] text-zinc-700 mb-3">
        These media buyers sent traffic to pages they weren't given. The leads came in, but no one was credited. Give them the page so future leads count.
      </p>
      <ul className="divide-y divide-amber-200">
        {missed.map((m) => {
          const key = `${m.media_buyer_id}:${m.give_page_id}`;
          return (
            <li key={key} className="py-2 flex items-center gap-3 flex-wrap text-[12px]" data-testid={`traffic-missed-${m.media_buyer_id}-${m.give_page_id}`}>
              <span className="font-bold">{m.media_buyer}</span>
              <span className="text-zinc-700">{m.leads} lead{m.leads === 1 ? "" : "s"} on <b>{m.page_title}</b>{m.give_title !== m.page_title && <> for <b>{m.give_title}</b></>}</span>
              <span className="label-mono text-zinc-500">last {new Date(m.last_at).toLocaleDateString()}</span>
              <button type="button" onClick={() => onGive(m)} disabled={busyKey === key} data-testid={`traffic-missed-give-${m.media_buyer_id}-${m.give_page_id}`}
                      className="ml-auto border-2 border-black bg-white px-2 py-1 text-[10px] uppercase tracking-widest inline-flex items-center gap-1 hover:bg-black hover:text-white disabled:opacity-50">
                <Plus size={10} weight="bold" /> Give them {m.give_kind === "buyer" ? "this buyer" : "this page"}
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
